import { LeafDivider } from "./divider.component.js";
customElements.define("leaf-divider", LeafDivider);
export {
  LeafDivider
};
//# sourceMappingURL=divider.js.map
